export enum PanelType {
  FullWidth = 1,
  Large = 2,
  Narrow = 3
}

export enum PanelThemeType {
  Light = 1,
  Dark = 2,
  Transparent = 3,
  Glass = 4,
  FlatDark = 5,
}